var map = {
	"./body-bgr-left": 63,
	"./body-bgr-left.png": 63,
	"./body-bgr-right": 64,
	"./body-bgr-right.png": 64,
	"./dashboard-img": 54,
	"./dashboard-img.png": 54,
	"./login-bg": 65,
	"./login-bg.jpg": 65,
	"./pdf-background": 47,
	"./pdf-background.png": 47,
	"./question-img": 66,
	"./question-img.png": 66,
	"./success-img": 55,
	"./success-img.png": 55,
	"./super": 56,
	"./super.png": 56,
	"./wellbeing-logo": 57,
	"./wellbeing-logo.png": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;